import type { FC, ReactNode } from "react";

import { PageGridHeaderRow } from "./PageGridHeaderRow";
import { PageRow } from "./PageRow";

import { SectionKind } from "components/server-types";
import { ScrollableTableContainer } from "components/tables/ScrollableTableContainer";
import { AccordionTitle } from "mds/components/AccordionTitle";

export const PageAccordionSection: FC<{
  pageIds: string[];
  sectionKind?: SectionKind;
  title: ReactNode;
  startOpen?: boolean;
}> = ({ pageIds, sectionKind, title, startOpen = true }) => {
  if (!pageIds.length) {
    return null;
  }

  return (
    <AccordionTitle
      className="py-3"
      collapsedHeaderClassName="justify-between py-0 border-b border-black-tint-90"
      headerClassName="justify-between py-0"
      iconPosition="end"
      startOpen={startOpen}
      title={title}
    >
      <ScrollableTableContainer className="mb-0 w-full">
        <PageGridHeaderRow sectionKind={sectionKind} />

        <div role="rowgroup">
          {pageIds.map((pageId) => (
            <PageRow key={pageId} pageId={pageId} sectionKind={sectionKind} />
          ))}
        </div>
      </ScrollableTableContainer>
    </AccordionTitle>
  );
};
